import React from "react";

var LeafAngleIcon = function LeafAngleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.505 1.088c-.484.029-11.894.743-15.659 4.503-3.205 3.202-3.702 7.448-1.498 10.92 2.214-2.897 5.777-6.88 10.716-10.334a1.002 1.002 0 0 1 1.393.246.998.998 0 0 1-.246 1.392C10.17 11.341 6.647 15.412 4.578 18.2a37.648 37.648 0 0 0-2.022 2.99l-.035.059-.092.156-.063.111A.998.998 0 0 0 3.24 23a1 1 0 0 0 .875-.513c.017-.03.71-1.247 2.046-3.046 3.529 2.432 7.942 1.992 11.242-1.305 3.765-3.761 4.479-15.159 4.508-15.643L22 1z"
  }));
};

LeafAngleIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
LeafAngleIcon.defaultProps.solid = true;
export default LeafAngleIcon;